import React, { useEffect, useState } from "react"
import { IFullCompanyDto } from "../../../types/company/IFullCompanyDto"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useNavigate } from "react-router-dom"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { Header } from "../../common/header/Header"
import { IMG } from "../../common/CONST"
import { MenuClient } from "../MenuClient"
import Input from "@/ui/components/Input"
import Skeleton from "@/ui/components/Skeleton"
import EmptyRow from "@/ui/components/EmptyRow"

export const ClientCompanyList = () => {
  const navigate = useNavigate()

  const [companies, setCompanies] = useState<IFullCompanyDto[]>([])
  const [filteredCompanies, setFilteredCompanies] = useState<IFullCompanyDto[]>([])
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [search, setSearch] = useState("")
  const [isLoading, setLoading] = useState(true)

  const getExclusions = (company: IFullCompanyDto): string => {
    let exclusions = ""
    if (company.countryExclusions && company.countryExclusions.length > 0) {
      const exclusionList = new Array<string>()
      company.countryExclusions.forEach(c => {
        if (c.name) exclusionList.push(c.name.toUpperCase())
      })
      exclusions = exclusionList.join(", ")
    }
    return exclusions
  }

  useEffect(() => {
    TrinityAPI.getCompanyList(
      response => {
        if (response.status === 200) {
          setCompanies(response.data)
          setFilteredCompanies(response.data)
        } else {
          setModalMessage({ title: "Ошибка!", text: "Не удалось загрузить список компаний: " + response.data.message })
        }
      },
      () => setLoading(false)
    )
  }, [])

  useEffect(() => {
    if (!search) {
      setFilteredCompanies(companies)
      return
    }

    setFilteredCompanies(
      companies.filter(
        c =>
          c.name?.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          (c.country && c.country.name && c.country.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())) ||
          c.currency?.toLocaleLowerCase().includes(search.toLocaleLowerCase())
      )
    )
  }, [search])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <MenuClient active={"company"} />
      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Реестр зарубежных компаний</h1>

          <section className="header-chapter">
            <div className="headr-chapter-name">
              <div className="header-chapter-icon">
                <img src={IMG.companies} alt="" className="header-chapter-img" />
              </div>
              <h2 className="heading-chapter">Все компании</h2>
            </div>
          </section>

          <section className="search-block">
            <Input
              type="search"
              onChange={e => setSearch(e.target.value)}
              placeholder="Поиск по названию, юрисдикции или валюте"
            />
          </section>

          <div className="main-content--wrapper">
            <section className="main-content">
              <ul className="header-global-list">
                <li className="header-global-item cols-company">Название</li>
                <li className="header-global-item cols-company">Специализация</li>
                <li className="header-global-item width-100">Юрисдикция</li>
                <li className="header-global-item cols-company">Страны исключения</li>
              </ul>
              <ul className="global-list">
                {isLoading && (
                  <div className="skeleton-wrapper">
                    <Skeleton rows={4} gutterTop />
                  </div>
                )}
                {!isLoading &&
                  (filteredCompanies.length > 0 ? (
                    filteredCompanies.map((c, index) => (
                      <li
                        className="global-item"
                        style={{ cursor: "pointer" }}
                        key={index}
                        onClick={() => navigate(`/company/${c.id}`)}
                      >
                        <div className="global-scroll-block">
                          <p className="global-item-text global-name cols-company">{c.name}</p>
                          <p className="global-item-text global-bank cols-company small-text-column">{c.okved}</p>
                          <p className="global-item-text globak-swift width-100 small-text-column">
                            {c.country?.name?.toUpperCase()}
                          </p>
                          <p className="global-item-text globak-num cols-company small-text-column">
                            {getExclusions(c)}
                          </p>
                        </div>
                      </li>
                    ))
                  ) : (
                    <EmptyRow text="Компаний не найдено" />
                  ))}
              </ul>
            </section>
          </div>
        </div>
      </main>
    </>
  )
}
